import React from 'react';
import {
  Col, Card, CardBody, Row, Button, CardHeader, Spinner, Alert,
} from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { PDFDownloadLink } from '@react-pdf/renderer';
import MyPdf from './Pdf';
import callDb, { baseURL } from '../../../utils/server';
import { saveFile } from '../../../utils/files';
import Collapse from '../../../shared/components/Collapse';
import { getCategoryName } from '../../../utils/functions';
import AssetModal from '../../Assets/components/AssetModal';
import AssetModalFull from './AssetModalFull';
import ModalFileViewer from '../../../shared/components/ModalFileViewer';
import ModalReport from './ModalReport';

const idLocale = require('moment/locale/fr');

moment.locale('fr', idLocale);

class UserInfo extends React.Component {
  static propTypes = {
    userInfo: PropTypes.shape({}).isRequired,
    toggleInfo: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isError: PropTypes.bool.isRequired,
    rawList: PropTypes.arrayOf(PropTypes.shape({})),
    list_assets: PropTypes.arrayOf(PropTypes.shape({})),
    contacts_pro: PropTypes.arrayOf(PropTypes.shape({})),
    contacts: PropTypes.arrayOf(PropTypes.shape({})),
    list_folders: PropTypes.arrayOf(PropTypes.shape({})),
    cleanList: PropTypes.arrayOf(PropTypes.shape({})),
    notary: PropTypes.shape({}),
    testament: PropTypes.shape({}),
    nb_after_death: PropTypes.number,
    nb_folders_after_death: PropTypes.number,
    last_updated: PropTypes.number,
    search_history: PropTypes.arrayOf(PropTypes.shape({})),
  };

  static defaultProps = {
    rawList: [],
    list_folders: [],
    cleanList: [],
    contacts_pro: [],
    contacts: [],
    list_assets: [],
    notary: {},
    testament: {},
    nb_after_death: 0,
    nb_folders_after_death: 0,
    last_updated: 0,
    search_history: [],
  };

  constructor() {
    super();
    this.state = {
      isModalAsset: false,
      isModalAssetFull: false,
      isModalReport: false,
      isModalDocument: false,
      isLoadedFile: false,
      assetData: {},
      assetDataFull: {},
      fileInfo: {},
    };
  }

  openAsset = (item) => {
    const { category } = item;
    const { isModalAssetFull } = this.state;
    if (['company', 'estate', 'album'].includes(category) && !isModalAssetFull) {
      this.setState({
        assetDataFull: item,
        isModalAssetFull: true,
      });
    } else {
      this.setState({
        assetData: item,
        isModalAsset: true,
      });
    }
  }

  setDocument = (data) => {
    this.setState({ isModalDocument: true, isLoadedFile: false });
    const { userInfo } = this.props;
    // MY UID IS FROM ACCESS RECEIVED, MUST EDIT THE FETCHING DOWNLOAD URL SERVER SIDE!!
    callDb({
      fullPath: data.fullPath,
      owner_uid: userInfo.uid,
    }, '/ficonum/download-url').then((result) => {
      const { token } = result.data;
      console.log('download-url result', result.data, `${baseURL}/files/decrypted-file/${data.name}?token=${token}`);
      this.setState({
        isLoadedFile: true,
        fileInfo: {
          ...data,
          url: `${baseURL}/files/decrypted-file/${data.name}?token=${token}`,
        },
      });
    });
  };

  toggleAsset = () => {
    this.setState(prevState => ({ isModalAsset: !prevState.isModalAsset }));
  }

  toggleAssetFull = () => {
    this.setState(prevState => ({ isModalAssetFull: !prevState.isModalAssetFull }));
  }

  toggleReport = () => {
    this.setState(prevState => ({ isModalReport: !prevState.isModalReport }));
  }

  toggleModalDocument = () => {
    this.setState(prevState => ({ isModalDocument: !prevState.isModalDocument }));
  }

  render() {
    const {
      toggleInfo, userInfo, isLoading, isError, rawList, list_folders, cleanList, nb_after_death, nb_folders_after_death, last_updated,
      contacts_pro, contacts, list_assets, notary, testament, search_history,
    } = this.props;
    const {
      isModalAsset, isModalAssetFull, isModalReport, isModalDocument, assetData, assetDataFull, isLoadedFile, fileInfo,
    } = this.state;
    if (isError) {
      return <Alert className="mt-20" color="danger">Cet utilisateur n'a souhaité partager aucune information avec le FICONUM.</Alert>;
    }
    return (
      <>
        <Row className="align-items-start">
          <Col md="2">
            <Button color="white" className="d-flex align-items-center justify-content-center fullWidth noBold" onClick={toggleInfo}>
              <ArrowLeftIcon /> Retour
            </Button>
          </Col>
          <Col md="10" xl="8">
            <Card>
              <CardHeader className="darkBack" style={{ padding: '2rem' }}>
                <h4 className="fw-500 text-center text-white">Legitbee de {userInfo.given_name} {userInfo.family_name}</h4>
              </CardHeader>
              {
                isLoading ? (
                  <div className="loaderContainer flex-column">
                    <div className="text-center mb-20">
                      <p>Veuillez patienter pendant le décryptage des données...</p>
                    </div>
                    <Spinner
                      color="primary"
                      role="status"
                      aria-hidden="true"
                    />
                  </div>
                ) : (
                  <div>
                    <CardBody>
                      <Row>
                        <Col style={{ borderRight: '1px solid #e3ebf6' }} className="d-flex align-items-center">
                          <div className="mr-10">
                            <img style={{ width: 42, height: 42 }} src={`${process.env.PUBLIC_URL}/img/check.svg`} alt="circle_check_icon" />
                          </div>
                          <div>
                            <div>
                              {rawList.length} élément{rawList.length > 1 && 's'} ouvert{rawList.length > 1 && 's'} au FICONUM
                            </div>
                            {
                              list_folders.length > 0 && (
                                <div>
                                  {list_folders.length} répertoire{list_folders.length !== 1 && 's'} ouvert{list_folders.length !== 1 && 's'} au FICONUM
                                </div>
                              )
                            }
                            <div>
                              <PDFDownloadLink document={<MyPdf contacts_pro={contacts_pro} last_updated={last_updated} cleanList={cleanList} list_assets={list_assets} userName={`${userInfo.given_name} ${userInfo.family_name}`} />} fileName={`${userInfo.given_name}_${userInfo.family_name}_Legitbee_${new Date().getTime()}.pdf`}>
                                {({ loading }) => (loading ? 'Chargement du document...' : (
                                  <Button color="link" className="blueish withUnderline">
                                    Télécharger PDF
                                  </Button>
                                ))}
                              </PDFDownloadLink>
                            </div>
                          </div>
                        </Col>
                        <Col className="d-flex align-items-center">
                          <div className="mr-10">
                            <img style={{ width: 42, height: 42 }} src={`${process.env.PUBLIC_URL}/img/lock.svg`} alt="lock_info_death_icon" />
                          </div>
                          <div>
                            <div>
                              {nb_after_death} section{nb_after_death !== 1 && 's'} verrouillée{nb_after_death !== 1 && 's'} jusqu'au décès
                            </div>
                            {
                              nb_folders_after_death > 0 && (
                                <div>
                                  {nb_folders_after_death} répertoire{nb_folders_after_death !== 1 && 's'} verrouillé{nb_folders_after_death !== 1 && 's'} jusqu'au décès
                                </div>
                              )
                            }
                            <div>
                              <Button onClick={this.toggleReport} color="link" className="blueish withUnderline">
                                Signaler {userInfo.given_name} comme décédé
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <div>
                      {
                        cleanList.map(item => (
                          <div key={item.title} style={{ background: 'white' }}>
                            <Collapse isOpen={false} title={item.title} className="mt-20 with-shadow">
                              <div style={{ paddingBottom: 20 }}>
                                {
                                  Object.keys(item.list).map((key) => {
                                    const list = item.list[key];
                                    return (
                                      <div key={key}>
                                        <div className="mt-20">
                                          <h3 className="bold-text">{getCategoryName(key)}</h3>
                                        </div>
                                        {
                                          list.filter(e => !e.linked_company_id).map(e => (
                                            <div key={e._id} className="mt-20">
                                              <Button onClick={() => this.openAsset(e)} color="link" className="blueish">
                                                {e.title}
                                              </Button>
                                            </div>
                                          ))
                                        }
                                      </div>
                                    );
                                  })
                                }
                              </div>
                            </Collapse>
                          </div>
                        ))
                      }
                      {/* {
                        list_folders && list_folders.length > 0 && (
                          <div style={{ background: 'white' }}>
                            <Collapse isOpen={false} title="Répertoires" className="mt-20 with-shadow">
                              <div style={{ paddingBottom: 20 }}>
                                {
                                  list_folders.map(e => (
                                    <div key={e.fullPath} className="mb-10">
                                      <Button onClick={() => this.openFolder(e)} color="link" className="blueish">
                                        /{/[^/]*$/.exec(e.fullPath)[0]}
                                      </Button>
                                    </div>
                                  ))
                                }
                              </div>
                            </Collapse>
                          </div>
                        )
                      } */}
                      {
                        (notary || testament) && (
                          <div style={{ background: 'white' }}>
                            <Collapse isOpen={false} title="Espace notarial" className="mt-20 with-shadow">
                              <div style={{ paddingBottom: 20 }}>
                                {
                                  notary && (
                                    <div>
                                      <div className="mt-20">
                                        <h3 className="bold-text">Notaire désigné</h3>
                                      </div>
                                      <p>{notary.name}</p>
                                      <p className="mt-0">Adresse : {notary.address}</p>
                                    </div>
                                  )
                                }
                                {
                                  testament && (
                                    <div>
                                      <div className="mt-20">
                                        <h3 className="bold-text">Testament olographe</h3>
                                      </div>
                                      <p>Lieu de conservation : {testament.location}</p>
                                      <p className="mt-0">Mis en ligne le : {moment(testament.created_at).format('L')}</p>
                                      <Button onClick={() => this.setDocument(testament)} color="link" className="blueish">
                                        {testament.name}
                                      </Button>
                                    </div>
                                  )
                                }
                              </div>
                            </Collapse>
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
              }
            </Card>
          </Col>
          <Col xl="2">
            <Card>
              <CardHeader>
                Historique des recherches :
              </CardHeader>
              <CardBody>
                {search_history.length === 0 && 'Pas de recherche récente.'}
                {search_history.length > 0 && search_history.map(e => (
                  <div>
                    {e.notary_name} / {e.notary_agency}
                    <br />Le : {moment(e.updated_at).format('L')}
                  </div>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
        { isModalAsset && <AssetModal contacts={contacts} userInfo={userInfo} toggleAsset={this.toggleAsset} setDocument={this.setDocument} isModalAsset={isModalAsset} data={assetData} /> }
        { isModalAssetFull && <AssetModalFull userInfo={userInfo} contacts_pro={contacts_pro} toggle={this.toggleAssetFull} openAsset={this.openAsset} setDocument={this.setDocument} isModal={isModalAssetFull} data={assetDataFull} list_assets={list_assets} /> }
        { isModalReport && <ModalReport isModal={isModalReport} toggle={this.toggleReport} userInfo={userInfo} />}
        { isModalDocument && <ModalFileViewer isModal={isModalDocument} saveFile={saveFile} fileInfo={fileInfo} toggle={this.toggleModalDocument} isLoadedFile={isLoadedFile} /> }
      </>
    );
  }
}

export default UserInfo;
